function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon/Big/TwoDrops");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "assets",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "styleguide",
  transform: "translate(-270.000000, -845.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon/Big/TwoDrops",
  transform: "translate(270.000000, 845.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M50.1111951,0.254079021 C51.2498049,1.30785426 78,26.2361657 78,41.6218517 C78,57.2695627 65.1984878,70 49.4634146,70 C48.5873415,70 47.6979512,69.9593247 46.821878,69.8798658 C46.2987073,69.831623 45.9134634,69.371897 45.9619756,68.8516309 C46.0095366,68.3313649 46.4689756,67.9482599 46.9959512,67.9955568 C47.814,68.0702859 48.6444146,68.1081234 49.4634146,68.1081234 C64.1492927,68.1081234 76.097561,56.2261928 76.097561,41.6218517 C76.097561,28.3285811 53.6002683,6.20686859 49.4624634,2.25190066 C48.3628537,3.30000027 45.9648293,5.62984624 43.0617073,8.71265909 C42.7011951,9.09292627 42.0990732,9.11279098 41.7166829,8.75617225 C41.3333415,8.39955352 41.3133659,7.80077459 41.6729268,7.41956146 C45.708,3.13540701 48.7851951,0.282457169 48.8156341,0.254079021 C49.1809024,-0.0845668819 49.7459268,-0.0845668819 50.1111951,0.254079021 Z M29.1843659,0.253984427 C30.3229756,1.30775967 57.0731707,26.2360711 57.0731707,41.6217571 C57.0731707,57.2694681 44.2716585,69.9999054 28.5365854,69.9999054 C12.8015122,69.9999054 9.59232693e-14,57.2694681 9.59232693e-14,41.6217571 C9.59232693e-14,26.2360711 26.7501951,1.30775967 27.8888049,0.253984427 C28.2540732,-0.0846614757 28.8190976,-0.0846614757 29.1843659,0.253984427 Z M28.5365854,2.25180607 C24.396878,6.20961181 1.90243902,28.3294325 1.90243902,41.6217571 C1.90243902,56.2270441 13.8507073,68.1080289 28.5365854,68.1080289 C43.2224634,68.1080289 55.1707317,56.2270441 55.1707317,41.6217571 C55.1707317,28.3294325 32.6762927,6.20961181 28.5365854,2.25180607 Z",
  id: "Combined-Shape"
}))));

var SvgTwoDrops = function SvgTwoDrops(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "70px",
    viewBox: "0 0 78 70",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwoDrops, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/two-drops.36e2ae79.svg";
export { ForwardRef as ReactComponent };